<template>
  <div class="sequences-tile__wrapper" :data-id="id">
    <h5>{{title}}</h5>
    <p v-if="exerciseCount && dayCount">{{dayCount}} day{{dayCount > 1 ? 's':''}}  containing {{exerciseCount}} {{exerciseCount > 1 ? 'activities':'activity'}}</p>
    <div class="sequences-tile__avatar-list" v-if="computedParticipants">
      <div class="sequences-tile__avatar-image" v-for="(participant, index) in computedParticipants" :key="id+'-'+index" @click.stop="$emit('assigned')">
        <img :src="participant.thumbnailUrl ? participant.thumbnailUrl : require('@/assets/placeholder96x96.png')"/>
      </div>
      <div class="sequences-tile__avatar-more" v-if="remainingParticipants">
        <strong>+{{remainingParticipants}}</strong> more
      </div>
    </div>
    <v-icon v-if="draft" class="sequences-tile__draft" size="24" color="bhGray">bhi-edit</v-icon>
    <sequence-more-menu 
      class="sequences-tile__menu"
      :id="id"
      :menu="menuHandler"
      :assignable="assignable"
      :draft="draft"
      :sharable="sharable"
      @changeMenuType="changeMenu"
      v-on="$listeners"
      :collectionMode="collectionMode"
      :imported="collectionIsOwned"
      @import="importSequence(id)"
      @rename-trigger="$emit('rename', id, title)"
    ></sequence-more-menu>
    <v-btn 
      icon 
      small
      text 
      v-if="readonly && collectionMode" 
      class="sequences-tile__collection" 
      :class="collectionIsOwned ? 'owned' : ''">
      <v-icon>bhi-copy</v-icon>
    </v-btn>
  </div>
</template>
<script>
/**
 * @todo: check if there needs to change participant.thumbnail image to profile-preview-image
 */
import SequenceMoreMenu from '@/components/exercises/SequenceMoreMenu.vue';
export default {
  name: 'SequenceTile',
  components: {
    SequenceMoreMenu,
  },
  props: {
    thumbnail: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    dayCount: {
      type: [Number, null],
      default: null
    },
    exerciseCount: {
      type: [Number, null],
      default: null
    },
    media: {
      type: Object,
      default: () => ({
        fileTypeId: 18,
        resourceId: null,
        thumbnail: null,
        isProcessing: false
      })
    },
    participants: {
      type: Array,
      default: ()=>{[]}
    },
    getResourceById: {
      type: Function,
      default: () => null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    collectionMode: {
      type: Boolean,
      default: false
    },
    collectionIsOwned: {
      type: Boolean,
      default: false
    },
    assignable: {
      type: Boolean,
      default: false
    },
    draft: {
      type: Boolean,
      default: false
    },
    sharable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuHandler: false,
      exerciseResource: null
    }
  },
  watch: {
    // resourceId(val) {
    //   if (val) {
    //     this.exerciseResource = this.getResourceById(val)
    //   }
    // }
  },
  computed: {
    computedParticipants() {
      if (this.participants && this.participants.length>0) {
        return this.participants.slice(0, 9)
      } else return false
    },
    remainingParticipants() {
      if (this.participants) {
        if (this.participants.length > 9) return 0
        else return this.participants.length - 9 > 0 ? this.participants.length - 9 : 0
      } else return 0
    }
  },
  methods: {
    changeMenu(type) {
      this.menuHandler = type
    },
    importSequence(id) {
      this.$emit('import-sequence', id)
    },
    placeholder (fileTypeId) {
      let image = 'placeholder_other.png'
      switch (fileTypeId) {
        case 17:
          image = 'placeholder_other.png'
          break
        case 18:
          image = 'placeholder_image.png'
          break
        case 19:
          image = 'placeholder_video.png'
          break
        case 20:
          image = 'placeholder_pdf.png'
          break
        case 21:
          image = 'placeholder_doc.png'
          break
        case 22:
          image = 'placeholder_presentation.png'
          break
        case 23:
          image = 'placeholder_sheet.png'
          break
        default:
          break
      }
      return require('@/assets/'+image)
    }
  }
}
</script>

<style lang="scss">
.sequences-tile {
  &__wrapper {
    width: 286px;
    height: 216px;
    border: 1px solid $bh-white;
    border-radius: 16px;
    padding: $gutter;
    margin: 8px;
    background: $bh-white;
    position: relative;
    cursor: pointer;
    &.selected {
      border-color:$bh-blue--2;
      cursor: grab;
    }
    &.bordered {
      border-color: $bh-blue;
      background: transparent;
    }
    .v-btn {
      margin-bottom: 5px;
    }
    h5 {
      color: $bh-black;
    }

    &:hover {
      .sequences-tile__menu {
        opacity: 1;
      }
      .sequences-tile__collection {
        opacity: 0;
      }
    }
  }
  &__menu {
    position: absolute;
    right: $gutter/2;
    top: $gutter/2;
    opacity: 0;
    z-index: 1;
    transition-duration: 300ms;
  }
  &__draft {
    position:absolute !important;
    right: $gutter/2;
    bottom: $gutter/2;
  }
  &__avatar {
    &-list {
      display: flex;
      flex-wrap: wrap;
    }
    &-image {
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
        display: block;
      }
      &:nth-child(n+1) {
        margin-left: -4px;
      }
    }
    &-more {
      line-height: 24px;
      margin-left:4px;
    }
  }
  &__collection {
    position: absolute;
    right: $gutter/2;
    top: $gutter/2;
    transition-duration: 300ms;
    &.owned {
      background: $bh-blue;
      .v-icon {
        color: $bh-white;
      }
    }
  }
}
</style>